import type { RouteConfig } from 'vue-router';
import { Role } from '@/modules/shared/types';

const route: RouteConfig = {
    path: '/:customer/documents',
    name: 'documents',
    component: () => import(/* webpackChunkName: "ctx-documents-documents" */ './Documents.vue'),
    meta: {
        role: Role.USER,
        license: [],
        authenticated: true,
        settingsTabs: true,
        portfolioTabs: false,
        navbar: true,
        footer: true,
        onboarding: true,
        notifications: true,
    },
};

export { route };
